import React, { createContext, useContext, useState, useCallback } from "react";

const dict = {
  fr: {
    // nav / common
    login: "Connexion",
    logout: "Déconnexion",
    signup: "Inscription",
    home: "Accueil",
    discover: "Découvrir",
    campaigns: "Campagnes",
    messages: "Messages",
    profile: "Profil",
    dashboard: "Tableau de bord",
    search: "Rechercher…",
    seeAll: "Voir tout",
    save: "Enregistrer",
    cancel: "Annuler",
    send: "Envoyer",
    loading: "Chargement…",
    back: "Retour",
    // landing
    heroTitle1: "Transformer",
    heroTitle2: "l'influence",
    heroTitle3: "en clients.",
    heroSubtitle: "La plateforme d'acquisition de clients grâce aux créateurs locaux.",
    imBusiness: "Je suis commerçant",
    imCreator: "Je suis créateur",
    newClients: "Nouveaux clients",
    onAverage: "en moyenne",
    businessesSupported: "commerçants déjà accompagnés",
    howItWorks: "Comment ça marche ?",
    step1Title: "Publiez votre offre",
    step1Desc: "Décrivez votre besoin en quelques minutes.",
    step2Title: "Recevez des propositions",
    step2Desc: "Des créateurs locaux vous envoient leurs idées.",
    step3Title: "Gagnez de nouveaux clients",
    step3Desc: "Vous ne payez que pour les résultats.",
    feat1: "Créateurs locaux authentiques",
    feat2: "Campagnes ciblées et mesurables",
    feat3: "Plus de clients, plus de croissance",
    ctaTitle: "Prêt à faire grandir votre commerce ?",
    ctaBtn: "Commencer gratuitement",
    conceptTitle: "Comment fonctionne Local Creators ?",
    conceptSub: "Un échange gagnant-gagnant entre commerces et créateurs locaux.",
    p1Title: "Le commerce publie sa demande",
    p1Desc: "Un établissement a besoin de visibilité et de contenu : il crée une mission en quelques clics.",
    p2Title: "Les créateurs reçoivent l'offre",
    p2Desc: "Les créateurs locaux voient les missions autour d'eux et postulent à celles qui leur plaisent.",
    p3Title: "On se met d'accord",
    p3Desc: "Du contenu contre un plat offert, un service ou une rémunération : le commerce accepte le créateur idéal.",
    p4Title: "Livraison & réutilisation",
    p4Desc: "Le créateur livre ses médias. Le commerce les télécharge, les réutilise et peut les afficher sur son profil Local Creators.",
    exampleContent: "Exemples de contenus créés",
    exampleContentSub: "Des vidéos authentiques tournées chez des commerces locaux.",
    forCreatorsTitle: "Pour les créateurs",
    forCreatorsDesc: "Inscription sur abonnement, accès à toutes les missions locales et un profil vérifié qui inspire confiance.",
    forBusinessTitle: "Pour les commerces",
    forBusinessDesc: "Publiez des missions, recevez des candidatures et récupérez des contenus prêts à l'emploi.",
    deliverablesTitle: "Des médias prêts à l'emploi",
    deliverablesDesc: "Chaque collaboration vous donne un lien de téléchargement des contenus livrés, réutilisables sur vos réseaux et votre profil.",
    discoverConcept: "Découvrir le concept",
    footerTagline: "La plateforme d'acquisition de clients grâce aux créateurs locaux.",
    footerProduct: "Produit",
    footerCompany: "Entreprise",
    footerLegal: "Légal",
    linkHowItWorks: "Comment ça marche",
    linkForBusiness: "Pour les commerces",
    linkForCreators: "Pour les créateurs",
    linkAbout: "À propos",
    linkContact: "Contact",
    linkLegalNotice: "Mentions légales",
    linkTerms: "Conditions générales de vente (CGV)",
    linkTermsUse: "Conditions générales d'utilisation (CGU)",
    linkPrivacy: "Politique de confidentialité",
    linkCookies: "Gestion des cookies",
    linkAccessibility: "Accessibilité",
    allRights: "Tous droits réservés.",
    lastUpdate: "Dernière mise à jour",
    backHome: "Retour à l'accueil",
    deliverables: "Livrables",
    deliverySpace: "Espace de livraison",
    noDeliverables: "Aucun livrable pour le moment.",
    addMedia: "Ajouter un média",
    uploading: "Envoi…",
    uploaded: "Média envoyé",
    download: "Télécharger",
    publish: "Publier sur mon profil",
    published: "Publié",
    unpublish: "Retirer",
    deliverInfo: "Photos et vidéos livrées au commerce (max 60 Mo).",
    subscribe: "S'abonner",
    subscribeToApply: "Abonnez-vous pour postuler aux missions.",
    subscriptionActive: "Abonnement actif",
    premiumCreator: "Créateur Premium",
    perMonth: "/ mois",
    subscribeCta: "Débloquer les missions",
    subscribeDesc: "Accédez à toutes les missions locales et postulez en illimité.",
    cookieText: "Nous utilisons des cookies pour améliorer votre expérience.",
    accept: "Accepter",
    decline: "Refuser",
    learnMore: "En savoir plus",
    adminBackoffice: "Back-office",
    navOverview: "Vue d'ensemble",
    navEstablishments: "Établissements",
    navCreators: "Créateurs",
    navSubscriptions: "Abonnements",
    navBilling: "Facturation",
    navTraffic: "Trafic web",
    navConfig: "Configuration",
    activeSubscriptions: "Abonnements actifs",
    totalRevenue: "Chiffre d'affaires",
    webTraffic: "Trafic web",
    totalViews: "Vues totales",
    last14days: "14 derniers jours",
    licenseOrders: "Commandes de licence",
    monthlyPrice: "Prix mensuel (€)",
    commission: "Commission plateforme (%)",
    platformName: "Nom de la plateforme",
    primaryColor: "Couleur principale",
    saveConfig: "Enregistrer la configuration",
    configSaved: "Configuration enregistrée",
    appConfig: "Configuration de l'application",
    contractTemplate: "Modèle de contrat",
    contractTemplateHint: "Rédigez le modèle. Insérez des balises dynamiques via le menu ci-dessus.",
    contractPreview: "Aperçu en direct",
    insertTag: "Insérer une balise",
    resetDefault: "Réinitialiser au modèle par défaut",
    status: "Statut",
    amount: "Montant",
    date: "Date",
    noData: "Aucune donnée.",
    campaignsCount: "Campagnes",
    menu: "Menu",
    gallery: "Galerie",
    openingHours: "Horaires",
    pageViews: "vues",
    collabTerms: "Conditions de collaboration",
    applyToCollab: "Postuler à une collaboration",
    realisationsShowcase: "Contenus réalisés ici",
    filters: "Filtres",
    distance: "Distance",
    minBudget: "Budget min",
    allCat: "Toutes",
    assistantTitle: "Assistant Local Creators",
    assistantIntro: "Bonjour ! Je vous explique comment fonctionne Local Creators. Posez-moi vos questions 😊",
    assistantPlaceholder: "Écrivez votre question…",
    assistantOpen: "Besoin d'aide ?",
    reward: "Contrepartie",
    rewardType: "Type de contrepartie",
    rewardMeal: "Repas offert",
    rewardPay: "Rémunération",
    rewardProduct: "Produit offert",
    rewardOther: "Autre",
    rewardValue: "Détail de la contrepartie",
    rewardValuePh: "ex : Menu pour 2, ou 300 €",
    contract: "Contrat",
    viewContract: "Voir le contrat",
    signContract: "Lire et signer le contrat",
    signAccept: "J'accepte et je signe",
    contractSigned: "Contrat signé",
    signedOn: "Signé le",
    activatePayouts: "Activer les paiements",
    payoutsActive: "Paiements activés",
    payoutsDesc: "Reliez votre compte Stripe pour recevoir vos paiements (net de commission).",
    invoice: "Facture",
    downloadPdf: "Télécharger le PDF",
    netToCreator: "Net créateur",
    memberProfile: "Profil membre",
    enableNotifs: "Activer les notifications",
    notifsEnabled: "Notifications activées 🔔",
    notifsDenied: "Notifications refusées",
    notifsUnsupported: "Notifications non supportées sur cet appareil",
    downloadPdf: "Télécharger le PDF",
    experienceLevel: "Niveau d'expérience",
    radiusOfAction: "Rayon d'intervention",
    socialLinks: "Réseaux sociaux",
    filterAll: "Tout",
    filterVideos: "Vidéos",
    filterPhotos: "Photos",
    totalViews: "Vues totales",
    aboutTitle: "À propos",
    openingHours: "Horaires d'ouverture",
    reviewsTitle: "Avis clients",
    activeCampaigns: "Missions ouvertes",
    locationTitle: "Localisation",
    followUs: "Suivez-nous",
    viewCampaign: "Voir la mission",
    navContracts: "Contrats",
    signedContracts: "Contrats signés",
    suspend: "Suspendre",
    unsuspend: "Réactiver",
    suspended: "Suspendu",
    activeLabel: "Actif",
    editMember: "Modifier",
    saveChanges: "Enregistrer",
    noContracts: "Aucun contrat signé",
    backToAdmin: "Retour au back-office",
    // login
    welcomeBack: "Bon retour",
    loginSubtitle: "Connectez-vous à votre espace Local Creators.",
    email: "Email",
    password: "Mot de passe",
    name: "Nom",
    noAccount: "Pas encore de compte ?",
    haveAccount: "Déjà inscrit ?",
    createAccount: "Créer un compte",
    quickAccess: "Accès rapide démo",
    prelaunchNotice: "Mode pré-lancement — ces accès seront masqués après le lancement public.",
    demoAdmin: "Démo Admin",
    demoBusiness: "Démo Commerçant",
    demoCreator: "Démo Créateur",
    chooseRole: "Je m'inscris en tant que",
    roleBusiness: "Commerçant",
    roleCreator: "Créateur",
    // creator home
    hello: "Bonjour",
    readyDiscover: "Prête à découvrir et collaborer avec des commerces locaux ?",
    searchBusiness: "Rechercher un restaurant, une cuisine…",
    nearYou: "Autour de toi",
    withinRadius: "Dans un rayon de 5 km",
    suggestedForYou: "Suggestions pour toi",
    popularCategories: "Catégories populaires",
    collabBanner: "Collabore et gagne des récompenses",
    collabBannerSub: "Plus tu collabores, plus tu gagnes !",
    new: "Nouveau",
    // map
    locateMe: "Me localiser",
    geoDenied: "Localisation indisponible — carte centrée sur Lyon.",
    missionsNear: "missions près de toi",
    candidatesNear: "créateurs près de toi",
    nearbyMissionsTitle: "Missions autour de toi",
    viewMissions: "Voir les missions",
    legendBusiness: "Commerces",
    legendMission: "Missions",
    legendCreator: "Créateurs",
    legendYou: "Toi",
    mapView: "Vue carte",
    // discover
    discoverCreators: "Découvrir les créateurs",
    discoverCreatorsSub: "Trouvez le créateur local idéal pour votre commerce.",
    followers: "Abonnés",
    avgViews: "Vues moyennes",
    engagement: "Taux d'engagement",
    posts: "Posts publiés",
    viewProfile: "Voir le profil",
    // creator profile
    trustedCreator: "Créateur de confiance",
    approvedBy: "Approuvé par la communauté des commerçants",
    avgRating: "Note moyenne des commerçants",
    basedOn: "Basée sur",
    reviews: "avis",
    detailedPerf: "Performance détaillée",
    audience: "Audience",
    ageRange: "Tranche d'âge",
    topCities: "Localisation principale",
    latestContent: "Derniers contenus",
    sendMessage: "Envoyer un message",
    inviteCollab: "Inviter à collaborer",
    women: "Femmes",
    men: "Hommes",
    // campaigns
    myCampaigns: "Mes campagnes",
    openCampaigns: "Campagnes ouvertes",
    createCampaign: "Créer une campagne",
    newCampaign: "Nouvelle campagne",
    title: "Titre",
    description: "Description",
    category: "Catégorie",
    budget: "Budget (€)",
    city: "Ville",
    proposals: "propositions",
    apply: "Postuler",
    applied: "Candidature envoyée",
    accept: "Accepter",
    reject: "Refuser",
    accepted: "Accepté",
    rejected: "Refusé",
    pending: "En attente",
    noCampaigns: "Aucune campagne pour le moment.",
    applyMessage: "Votre message au commerçant",
    missionsOnMap: "Missions sur la carte",
    // payments
    payShort: "Payer",
    payCreator: "Payer le créateur",
    paid: "Payé",
    securePayment: "Paiement sécurisé via Stripe",
    paymentSuccess: "Paiement réussi !",
    paymentSuccessSub: "La collaboration est confirmée. Le créateur a été notifié.",
    paymentPending: "Paiement en cours de traitement",
    paymentPendingSub: "Nous confirmons votre paiement, cela peut prendre un instant.",
    paymentCancelled: "Paiement annulé",
    paymentCancelledSub: "Aucun montant n'a été débité.",
    paymentVerifying: "Vérification du paiement…",
    backToCampaigns: "Retour aux campagnes",
    // messages
    conversations: "Conversations",
    noConversations: "Aucune conversation pour le moment.",
    noMessages: "Démarrez la conversation !",
    typeMessage: "Écrivez un message…",
    selectConversation: "Sélectionnez une conversation",
    // admin
    welcomeAdmin: "Bienvenue",
    adminOverview: "Voici un aperçu de la santé de votre plateforme.",
    kpiCreators: "Créateurs",
    kpiBusinesses: "Commerces",
    kpiCollabs: "Collaborations",
    kpiViews: "Vues générées",
    totalRegistered: "Total inscrits",
    inProgress: "en cours",
    signupEvolution: "Évolution des inscriptions",
    userDistribution: "Répartition des utilisateurs",
    totalUsers: "Utilisateurs au total",
    topCategories: "Top catégories de commerces",
    pendingRequests: "Demandes en attente",
    pendingCreators: "Demandes de créateurs",
    pendingBusinesses: "Demandes de commerces",
    revenue: "Revenus générés",
    users: "Utilisateurs",
    verify: "Valider",
    verified: "Vérifié",
    // profile
    myProfile: "Mon profil",
    editProfile: "Modifier le profil",
    role: "Rôle",
    realisations: "Réalisations",
    views: "vues",
  },
  en: {
    login: "Login",
    logout: "Logout",
    signup: "Sign up",
    home: "Home",
    discover: "Discover",
    campaigns: "Campaigns",
    messages: "Messages",
    profile: "Profile",
    dashboard: "Dashboard",
    search: "Search…",
    seeAll: "See all",
    save: "Save",
    cancel: "Cancel",
    send: "Send",
    loading: "Loading…",
    back: "Back",
    heroTitle1: "Turning",
    heroTitle2: "influence",
    heroTitle3: "into customers.",
    heroSubtitle: "The customer acquisition platform powered by local creators.",
    imBusiness: "I'm a Business",
    imCreator: "I'm a Creator",
    newClients: "New customers",
    onAverage: "on average",
    businessesSupported: "businesses already supported",
    howItWorks: "How does it work?",
    step1Title: "Post your offer",
    step1Desc: "Describe your need in a few minutes.",
    step2Title: "Receive proposals",
    step2Desc: "Local creators send you their ideas.",
    step3Title: "Get new customers",
    step3Desc: "You only pay for results.",
    feat1: "Authentic local creators",
    feat2: "Targeted and measurable campaigns",
    feat3: "More customers, more growth",
    ctaTitle: "Ready to grow your business?",
    ctaBtn: "Start for free",
    conceptTitle: "How does Local Creators work?",
    conceptSub: "A win-win exchange between local businesses and creators.",
    p1Title: "The business posts its request",
    p1Desc: "A venue needs visibility and content: it creates a mission in a few clicks.",
    p2Title: "Creators receive the offer",
    p2Desc: "Local creators see missions around them and apply to the ones they like.",
    p3Title: "You agree on the deal",
    p3Desc: "Content in exchange for a free meal, a service or a fee: the business accepts the ideal creator.",
    p4Title: "Delivery & reuse",
    p4Desc: "The creator delivers the media. The business downloads it, reuses it and can showcase it on its Local Creators profile.",
    exampleContent: "Examples of created content",
    exampleContentSub: "Authentic videos shot at local businesses.",
    forCreatorsTitle: "For creators",
    forCreatorsDesc: "Subscription sign-up, access to every local mission and a verified, trustworthy profile.",
    forBusinessTitle: "For businesses",
    forBusinessDesc: "Post missions, receive applications and get ready-to-use content.",
    deliverablesTitle: "Ready-to-use media",
    deliverablesDesc: "Every collaboration gives you a download link for the delivered content, reusable on your socials and profile.",
    discoverConcept: "Discover the concept",
    footerTagline: "The customer acquisition platform powered by local creators.",
    footerProduct: "Product",
    footerCompany: "Company",
    footerLegal: "Legal",
    linkHowItWorks: "How it works",
    linkForBusiness: "For businesses",
    linkForCreators: "For creators",
    linkAbout: "About",
    linkContact: "Contact",
    linkLegalNotice: "Legal notice",
    linkTerms: "Terms of sale",
    linkTermsUse: "Terms of use",
    linkPrivacy: "Privacy policy",
    linkCookies: "Cookie settings",
    linkAccessibility: "Accessibility",
    allRights: "All rights reserved.",
    lastUpdate: "Last updated",
    backHome: "Back to home",
    deliverables: "Deliverables",
    deliverySpace: "Delivery space",
    noDeliverables: "No deliverables yet.",
    addMedia: "Add media",
    uploading: "Uploading…",
    uploaded: "Media uploaded",
    download: "Download",
    publish: "Publish on my profile",
    published: "Published",
    unpublish: "Unpublish",
    deliverInfo: "Photos and videos delivered to the business (max 60 MB).",
    subscribe: "Subscribe",
    subscribeToApply: "Subscribe to apply to missions.",
    subscriptionActive: "Subscription active",
    premiumCreator: "Premium Creator",
    perMonth: "/ month",
    subscribeCta: "Unlock missions",
    subscribeDesc: "Access every local mission and apply without limits.",
    cookieText: "We use cookies to improve your experience.",
    accept: "Accept",
    decline: "Decline",
    learnMore: "Learn more",
    adminBackoffice: "Back office",
    navOverview: "Overview",
    navEstablishments: "Establishments",
    navCreators: "Creators",
    navSubscriptions: "Subscriptions",
    navBilling: "Billing",
    navTraffic: "Web traffic",
    navConfig: "Configuration",
    activeSubscriptions: "Active subscriptions",
    totalRevenue: "Revenue",
    webTraffic: "Web traffic",
    totalViews: "Total views",
    last14days: "Last 14 days",
    licenseOrders: "License orders",
    monthlyPrice: "Monthly price (€)",
    commission: "Platform commission (%)",
    platformName: "Platform name",
    primaryColor: "Primary color",
    saveConfig: "Save configuration",
    configSaved: "Configuration saved",
    appConfig: "App configuration",
    contractTemplate: "Contract template",
    contractTemplateHint: "Write the template. Insert dynamic tags using the menu above.",
    contractPreview: "Live preview",
    insertTag: "Insert tag",
    resetDefault: "Reset to default template",
    status: "Status",
    amount: "Amount",
    date: "Date",
    noData: "No data.",
    campaignsCount: "Campaigns",
    menu: "Menu",
    gallery: "Gallery",
    openingHours: "Hours",
    pageViews: "views",
    collabTerms: "Collaboration terms",
    applyToCollab: "Apply to collaborate",
    realisationsShowcase: "Content created here",
    filters: "Filters",
    distance: "Distance",
    minBudget: "Min budget",
    allCat: "All",
    assistantTitle: "Local Creators Assistant",
    assistantIntro: "Hi! Let me explain how Local Creators works. Ask me anything 😊",
    assistantPlaceholder: "Type your question…",
    assistantOpen: "Need help?",
    reward: "Reward",
    rewardType: "Reward type",
    rewardMeal: "Free meal",
    rewardPay: "Payment",
    rewardProduct: "Free product",
    rewardOther: "Other",
    rewardValue: "Reward details",
    rewardValuePh: "e.g. Meal for 2, or 300 €",
    contract: "Contract",
    viewContract: "View contract",
    signContract: "Read & sign contract",
    signAccept: "I accept and sign",
    contractSigned: "Contract signed",
    signedOn: "Signed on",
    activatePayouts: "Activate payouts",
    payoutsActive: "Payouts active",
    payoutsDesc: "Connect your Stripe account to receive payouts (net of commission).",
    invoice: "Invoice",
    downloadPdf: "Download PDF",
    netToCreator: "Net to creator",
    memberProfile: "Member profile",
    enableNotifs: "Enable notifications",
    notifsEnabled: "Notifications enabled 🔔",
    notifsDenied: "Notifications denied",
    notifsUnsupported: "Notifications not supported on this device",
    downloadPdf: "Download PDF",
    experienceLevel: "Experience level",
    radiusOfAction: "Service radius",
    socialLinks: "Social links",
    filterAll: "All",
    filterVideos: "Videos",
    filterPhotos: "Photos",
    totalViews: "Total views",
    aboutTitle: "About",
    openingHours: "Opening hours",
    reviewsTitle: "Reviews",
    activeCampaigns: "Open missions",
    locationTitle: "Location",
    followUs: "Follow us",
    viewCampaign: "View mission",
    navContracts: "Contracts",
    signedContracts: "Signed contracts",
    suspend: "Suspend",
    unsuspend: "Reactivate",
    suspended: "Suspended",
    activeLabel: "Active",
    editMember: "Edit",
    saveChanges: "Save",
    noContracts: "No signed contracts",
    backToAdmin: "Back to back office",
    welcomeBack: "Welcome back",
    loginSubtitle: "Sign in to your Local Creators space.",
    email: "Email",
    password: "Password",
    name: "Name",
    noAccount: "No account yet?",
    haveAccount: "Already registered?",
    createAccount: "Create account",
    quickAccess: "Quick demo access",
    prelaunchNotice: "Pre-launch mode — these shortcuts will be hidden after public launch.",
    demoAdmin: "Admin Demo",
    demoBusiness: "Business Demo",
    demoCreator: "Creator Demo",
    chooseRole: "I sign up as a",
    roleBusiness: "Business",
    roleCreator: "Creator",
    hello: "Hello",
    readyDiscover: "Ready to discover and collaborate with local businesses?",
    searchBusiness: "Search a restaurant, a cuisine…",
    nearYou: "Near you",
    withinRadius: "Within a 5 km radius",
    suggestedForYou: "Suggested for you",
    popularCategories: "Popular categories",
    collabBanner: "Collaborate and earn rewards",
    collabBannerSub: "The more you collaborate, the more you earn!",
    new: "New",
    locateMe: "Locate me",
    geoDenied: "Location unavailable — map centered on Lyon.",
    missionsNear: "missions near you",
    candidatesNear: "creators near you",
    nearbyMissionsTitle: "Missions around you",
    viewMissions: "View missions",
    legendBusiness: "Businesses",
    legendMission: "Missions",
    legendCreator: "Creators",
    legendYou: "You",
    mapView: "Map view",
    discoverCreators: "Discover creators",
    discoverCreatorsSub: "Find the perfect local creator for your business.",
    followers: "Followers",
    avgViews: "Average views",
    engagement: "Engagement rate",
    posts: "Posts published",
    viewProfile: "View profile",
    trustedCreator: "Trusted Creator",
    approvedBy: "Approved by the community of businesses",
    avgRating: "Average rating from businesses",
    basedOn: "Based on",
    reviews: "reviews",
    detailedPerf: "Detailed performance",
    audience: "Audience",
    ageRange: "Age range",
    topCities: "Top locations",
    latestContent: "Latest content",
    sendMessage: "Send a message",
    inviteCollab: "Invite to collaborate",
    women: "Women",
    men: "Men",
    myCampaigns: "My campaigns",
    openCampaigns: "Open campaigns",
    createCampaign: "Create a campaign",
    newCampaign: "New campaign",
    title: "Title",
    description: "Description",
    category: "Category",
    budget: "Budget (€)",
    city: "City",
    proposals: "proposals",
    apply: "Apply",
    applied: "Application sent",
    accept: "Accept",
    reject: "Reject",
    accepted: "Accepted",
    rejected: "Rejected",
    pending: "Pending",
    noCampaigns: "No campaigns yet.",
    applyMessage: "Your message to the business",
    missionsOnMap: "Missions on the map",
    payShort: "Pay",
    payCreator: "Pay the creator",
    paid: "Paid",
    securePayment: "Secure payment via Stripe",
    paymentSuccess: "Payment successful!",
    paymentSuccessSub: "The collaboration is confirmed. The creator has been notified.",
    paymentPending: "Payment processing",
    paymentPendingSub: "We're confirming your payment, this may take a moment.",
    paymentCancelled: "Payment cancelled",
    paymentCancelledSub: "No amount was charged.",
    paymentVerifying: "Verifying payment…",
    backToCampaigns: "Back to campaigns",
    conversations: "Conversations",
    noConversations: "No conversations yet.",
    noMessages: "Start the conversation!",
    typeMessage: "Type a message…",
    selectConversation: "Select a conversation",
    welcomeAdmin: "Welcome",
    adminOverview: "Here is an overview of your platform's health.",
    kpiCreators: "Creators",
    kpiBusinesses: "Businesses",
    kpiCollabs: "Collaborations",
    kpiViews: "Views generated",
    totalRegistered: "Total registered",
    inProgress: "in progress",
    signupEvolution: "Sign-up evolution",
    userDistribution: "User distribution",
    totalUsers: "Total users",
    topCategories: "Top business categories",
    pendingRequests: "Pending requests",
    pendingCreators: "Creator requests",
    pendingBusinesses: "Business requests",
    revenue: "Revenue generated",
    users: "Users",
    verify: "Verify",
    verified: "Verified",
    myProfile: "My profile",
    editProfile: "Edit profile",
    role: "Role",
    realisations: "Portfolio",
    views: "views",
  },
  vi: {
    login: "Đăng nhập",
    logout: "Đăng xuất",
    signup: "Đăng ký",
    home: "Trang chủ",
    discover: "Khám phá",
    campaigns: "Chiến dịch",
    messages: "Tin nhắn",
    profile: "Hồ sơ",
    dashboard: "Bảng điều khiển",
    search: "Tìm kiếm…",
    seeAll: "Xem tất cả",
    save: "Lưu",
    cancel: "Hủy",
    send: "Gửi",
    loading: "Đang tải…",
    back: "Quay lại",
    heroTitle1: "Biến",
    heroTitle2: "sức ảnh hưởng",
    heroTitle3: "thành khách hàng.",
    heroSubtitle: "Nền tảng thu hút khách hàng nhờ các nhà sáng tạo địa phương.",
    imBusiness: "Tôi là doanh nghiệp",
    imCreator: "Tôi là nhà sáng tạo",
    newClients: "Khách hàng mới",
    onAverage: "trung bình",
    businessesSupported: "doanh nghiệp đã được hỗ trợ",
    howItWorks: "Cách hoạt động?",
    step1Title: "Đăng nhu cầu của bạn",
    step1Desc: "Mô tả nhu cầu chỉ trong vài phút.",
    step2Title: "Nhận đề xuất",
    step2Desc: "Các nhà sáng tạo địa phương gửi ý tưởng cho bạn.",
    step3Title: "Có thêm khách hàng mới",
    step3Desc: "Bạn chỉ trả tiền cho kết quả.",
    feat1: "Nhà sáng tạo địa phương chân thực",
    feat2: "Chiến dịch nhắm mục tiêu và đo lường được",
    feat3: "Nhiều khách hàng hơn, tăng trưởng hơn",
    ctaTitle: "Sẵn sàng phát triển doanh nghiệp của bạn?",
    ctaBtn: "Bắt đầu miễn phí",
    conceptTitle: "Local Creators hoạt động thế nào?",
    conceptSub: "Trao đổi đôi bên cùng có lợi giữa doanh nghiệp và nhà sáng tạo địa phương.",
    p1Title: "Doanh nghiệp đăng yêu cầu",
    p1Desc: "Một cơ sở cần độ phủ và nội dung: tạo một nhiệm vụ chỉ trong vài cú nhấp.",
    p2Title: "Nhà sáng tạo nhận đề nghị",
    p2Desc: "Nhà sáng tạo địa phương thấy các nhiệm vụ quanh mình và ứng tuyển những gì họ thích.",
    p3Title: "Thống nhất thỏa thuận",
    p3Desc: "Nội dung đổi lấy một bữa ăn miễn phí, dịch vụ hoặc thù lao: doanh nghiệp chọn nhà sáng tạo lý tưởng.",
    p4Title: "Bàn giao & tái sử dụng",
    p4Desc: "Nhà sáng tạo bàn giao media. Doanh nghiệp tải về, tái sử dụng và có thể trưng bày trên hồ sơ Local Creators.",
    exampleContent: "Ví dụ nội dung đã tạo",
    exampleContentSub: "Video chân thực quay tại các doanh nghiệp địa phương.",
    forCreatorsTitle: "Dành cho nhà sáng tạo",
    forCreatorsDesc: "Đăng ký theo gói thuê bao, truy cập mọi nhiệm vụ địa phương và hồ sơ được xác minh đáng tin cậy.",
    forBusinessTitle: "Dành cho doanh nghiệp",
    forBusinessDesc: "Đăng nhiệm vụ, nhận ứng tuyển và nhận nội dung sẵn sàng sử dụng.",
    deliverablesTitle: "Media sẵn sàng sử dụng",
    deliverablesDesc: "Mỗi hợp tác cho bạn liên kết tải nội dung đã bàn giao, tái sử dụng trên mạng xã hội và hồ sơ.",
    discoverConcept: "Khám phá ý tưởng",
    footerTagline: "Nền tảng thu hút khách hàng nhờ các nhà sáng tạo địa phương.",
    footerProduct: "Sản phẩm",
    footerCompany: "Công ty",
    footerLegal: "Pháp lý",
    linkHowItWorks: "Cách hoạt động",
    linkForBusiness: "Dành cho doanh nghiệp",
    linkForCreators: "Dành cho nhà sáng tạo",
    linkAbout: "Giới thiệu",
    linkContact: "Liên hệ",
    linkLegalNotice: "Thông tin pháp lý",
    linkTerms: "Điều khoản bán hàng",
    linkTermsUse: "Điều khoản sử dụng",
    linkPrivacy: "Chính sách bảo mật",
    linkCookies: "Cài đặt cookie",
    linkAccessibility: "Khả năng tiếp cận",
    allRights: "Bảo lưu mọi quyền.",
    lastUpdate: "Cập nhật lần cuối",
    backHome: "Về trang chủ",
    deliverables: "Sản phẩm bàn giao",
    deliverySpace: "Khu vực bàn giao",
    noDeliverables: "Chưa có sản phẩm bàn giao.",
    addMedia: "Thêm media",
    uploading: "Đang tải lên…",
    uploaded: "Đã tải media lên",
    download: "Tải xuống",
    publish: "Đăng lên hồ sơ của tôi",
    published: "Đã đăng",
    unpublish: "Gỡ xuống",
    deliverInfo: "Ảnh và video bàn giao cho doanh nghiệp (tối đa 60 MB).",
    subscribe: "Đăng ký",
    subscribeToApply: "Đăng ký để ứng tuyển nhiệm vụ.",
    subscriptionActive: "Gói đang hoạt động",
    premiumCreator: "Nhà sáng tạo Premium",
    perMonth: "/ tháng",
    subscribeCta: "Mở khóa nhiệm vụ",
    subscribeDesc: "Truy cập mọi nhiệm vụ địa phương và ứng tuyển không giới hạn.",
    cookieText: "Chúng tôi dùng cookie để cải thiện trải nghiệm của bạn.",
    accept: "Chấp nhận",
    decline: "Từ chối",
    learnMore: "Tìm hiểu thêm",
    adminBackoffice: "Back office",
    navOverview: "Tổng quan",
    navEstablishments: "Cơ sở",
    navCreators: "Nhà sáng tạo",
    navSubscriptions: "Gói đăng ký",
    navBilling: "Thanh toán",
    navTraffic: "Lưu lượng web",
    navConfig: "Cấu hình",
    activeSubscriptions: "Gói đang hoạt động",
    totalRevenue: "Doanh thu",
    webTraffic: "Lưu lượng web",
    totalViews: "Tổng lượt xem",
    last14days: "14 ngày qua",
    licenseOrders: "Đơn cấp phép",
    monthlyPrice: "Giá hàng tháng (€)",
    commission: "Hoa hồng nền tảng (%)",
    platformName: "Tên nền tảng",
    primaryColor: "Màu chính",
    saveConfig: "Lưu cấu hình",
    configSaved: "Đã lưu cấu hình",
    appConfig: "Cấu hình ứng dụng",
    contractTemplate: "Mẫu hợp đồng",
    contractTemplateHint: "Soạn mẫu. Chèn thẻ động bằng menu phía trên.",
    contractPreview: "Xem trước trực tiếp",
    insertTag: "Chèn thẻ",
    resetDefault: "Đặt lại mẫu mặc định",
    status: "Trạng thái",
    amount: "Số tiền",
    date: "Ngày",
    noData: "Không có dữ liệu.",
    campaignsCount: "Chiến dịch",
    menu: "Thực đơn",
    gallery: "Thư viện",
    openingHours: "Giờ mở cửa",
    pageViews: "lượt xem",
    collabTerms: "Điều khoản hợp tác",
    applyToCollab: "Ứng tuyển hợp tác",
    realisationsShowcase: "Nội dung đã thực hiện tại đây",
    filters: "Bộ lọc",
    distance: "Khoảng cách",
    minBudget: "Ngân sách tối thiểu",
    allCat: "Tất cả",
    assistantTitle: "Trợ lý Local Creators",
    assistantIntro: "Xin chào! Tôi sẽ giải thích Local Creators hoạt động ra sao. Cứ hỏi tôi nhé 😊",
    assistantPlaceholder: "Nhập câu hỏi của bạn…",
    assistantOpen: "Cần trợ giúp?",
    reward: "Đãi ngộ",
    rewardType: "Loại đãi ngộ",
    rewardMeal: "Bữa ăn miễn phí",
    rewardPay: "Thù lao",
    rewardProduct: "Sản phẩm tặng",
    rewardOther: "Khác",
    rewardValue: "Chi tiết đãi ngộ",
    rewardValuePh: "vd: Bữa cho 2, hoặc 300 €",
    contract: "Hợp đồng",
    viewContract: "Xem hợp đồng",
    signContract: "Đọc & ký hợp đồng",
    signAccept: "Tôi chấp nhận và ký",
    contractSigned: "Đã ký hợp đồng",
    signedOn: "Đã ký ngày",
    activatePayouts: "Kích hoạt thanh toán",
    payoutsActive: "Đã kích hoạt thanh toán",
    payoutsDesc: "Kết nối tài khoản Stripe để nhận thanh toán (đã trừ hoa hồng).",
    invoice: "Hóa đơn",
    downloadPdf: "Tải PDF",
    netToCreator: "Net cho nhà sáng tạo",
    memberProfile: "Hồ sơ thành viên",
    enableNotifs: "Bật thông báo",
    notifsEnabled: "Đã bật thông báo 🔔",
    notifsDenied: "Thông báo bị từ chối",
    notifsUnsupported: "Thiết bị không hỗ trợ thông báo",
    downloadPdf: "Tải PDF",
    experienceLevel: "Cấp độ kinh nghiệm",
    radiusOfAction: "Bán kính hoạt động",
    socialLinks: "Mạng xã hội",
    filterAll: "Tất cả",
    filterVideos: "Video",
    filterPhotos: "Ảnh",
    totalViews: "Tổng lượt xem",
    aboutTitle: "Giới thiệu",
    openingHours: "Giờ mở cửa",
    reviewsTitle: "Đánh giá",
    activeCampaigns: "Nhiệm vụ đang mở",
    locationTitle: "Vị trí",
    followUs: "Theo dõi chúng tôi",
    viewCampaign: "Xem nhiệm vụ",
    navContracts: "Hợp đồng",
    signedContracts: "Hợp đồng đã ký",
    suspend: "Tạm ngưng",
    unsuspend: "Kích hoạt lại",
    suspended: "Đã tạm ngưng",
    activeLabel: "Hoạt động",
    editMember: "Chỉnh sửa",
    saveChanges: "Lưu",
    noContracts: "Chưa có hợp đồng đã ký",
    backToAdmin: "Về back office",
    welcomeBack: "Chào mừng trở lại",
    loginSubtitle: "Đăng nhập vào không gian Local Creators của bạn.",
    email: "Email",
    password: "Mật khẩu",
    name: "Tên",
    noAccount: "Chưa có tài khoản?",
    haveAccount: "Đã đăng ký?",
    createAccount: "Tạo tài khoản",
    quickAccess: "Truy cập demo nhanh",
    prelaunchNotice: "Chế độ trước ra mắt — các lối tắt này sẽ bị ẩn sau khi ra mắt công khai.",
    demoAdmin: "Demo Quản trị",
    demoBusiness: "Demo Doanh nghiệp",
    demoCreator: "Demo Nhà sáng tạo",
    chooseRole: "Tôi đăng ký với tư cách",
    roleBusiness: "Doanh nghiệp",
    roleCreator: "Nhà sáng tạo",
    hello: "Xin chào",
    readyDiscover: "Sẵn sàng khám phá và hợp tác với các doanh nghiệp địa phương?",
    searchBusiness: "Tìm nhà hàng, món ăn…",
    nearYou: "Quanh bạn",
    withinRadius: "Trong bán kính 5 km",
    suggestedForYou: "Gợi ý cho bạn",
    popularCategories: "Danh mục phổ biến",
    collabBanner: "Hợp tác và nhận thưởng",
    collabBannerSub: "Càng hợp tác, càng kiếm được nhiều!",
    new: "Mới",
    locateMe: "Định vị tôi",
    geoDenied: "Không có vị trí — bản đồ đặt ở Lyon.",
    missionsNear: "nhiệm vụ gần bạn",
    candidatesNear: "nhà sáng tạo gần bạn",
    nearbyMissionsTitle: "Nhiệm vụ quanh bạn",
    viewMissions: "Xem nhiệm vụ",
    legendBusiness: "Doanh nghiệp",
    legendMission: "Nhiệm vụ",
    legendCreator: "Nhà sáng tạo",
    legendYou: "Bạn",
    mapView: "Xem bản đồ",
    discoverCreators: "Khám phá nhà sáng tạo",
    discoverCreatorsSub: "Tìm nhà sáng tạo địa phương lý tưởng cho doanh nghiệp của bạn.",
    followers: "Người theo dõi",
    avgViews: "Lượt xem trung bình",
    engagement: "Tỷ lệ tương tác",
    posts: "Bài đăng",
    viewProfile: "Xem hồ sơ",
    trustedCreator: "Nhà sáng tạo đáng tin cậy",
    approvedBy: "Được cộng đồng doanh nghiệp chứng nhận",
    avgRating: "Đánh giá trung bình từ doanh nghiệp",
    basedOn: "Dựa trên",
    reviews: "đánh giá",
    detailedPerf: "Hiệu suất chi tiết",
    audience: "Khán giả",
    ageRange: "Độ tuổi",
    topCities: "Khu vực chính",
    latestContent: "Nội dung mới nhất",
    sendMessage: "Gửi tin nhắn",
    inviteCollab: "Mời hợp tác",
    women: "Nữ",
    men: "Nam",
    myCampaigns: "Chiến dịch của tôi",
    openCampaigns: "Chiến dịch đang mở",
    createCampaign: "Tạo chiến dịch",
    newCampaign: "Chiến dịch mới",
    title: "Tiêu đề",
    description: "Mô tả",
    category: "Danh mục",
    budget: "Ngân sách (€)",
    city: "Thành phố",
    proposals: "đề xuất",
    apply: "Ứng tuyển",
    applied: "Đã gửi ứng tuyển",
    accept: "Chấp nhận",
    reject: "Từ chối",
    accepted: "Đã chấp nhận",
    rejected: "Đã từ chối",
    pending: "Đang chờ",
    noCampaigns: "Chưa có chiến dịch nào.",
    applyMessage: "Tin nhắn của bạn gửi doanh nghiệp",
    missionsOnMap: "Nhiệm vụ trên bản đồ",
    payShort: "Thanh toán",
    payCreator: "Thanh toán cho nhà sáng tạo",
    paid: "Đã thanh toán",
    securePayment: "Thanh toán an toàn qua Stripe",
    paymentSuccess: "Thanh toán thành công!",
    paymentSuccessSub: "Hợp tác đã được xác nhận. Nhà sáng tạo đã được thông báo.",
    paymentPending: "Đang xử lý thanh toán",
    paymentPendingSub: "Chúng tôi đang xác nhận thanh toán, có thể mất một chút thời gian.",
    paymentCancelled: "Đã hủy thanh toán",
    paymentCancelledSub: "Không có khoản nào bị trừ.",
    paymentVerifying: "Đang xác minh thanh toán…",
    backToCampaigns: "Quay lại chiến dịch",
    conversations: "Cuộc trò chuyện",
    noConversations: "Chưa có cuộc trò chuyện nào.",
    noMessages: "Bắt đầu trò chuyện!",
    typeMessage: "Nhập tin nhắn…",
    selectConversation: "Chọn một cuộc trò chuyện",
    welcomeAdmin: "Chào mừng",
    adminOverview: "Đây là tổng quan về tình trạng nền tảng của bạn.",
    kpiCreators: "Nhà sáng tạo",
    kpiBusinesses: "Doanh nghiệp",
    kpiCollabs: "Hợp tác",
    kpiViews: "Lượt xem tạo ra",
    totalRegistered: "Tổng đã đăng ký",
    inProgress: "đang diễn ra",
    signupEvolution: "Diễn biến đăng ký",
    userDistribution: "Phân bố người dùng",
    totalUsers: "Tổng người dùng",
    topCategories: "Danh mục doanh nghiệp hàng đầu",
    pendingRequests: "Yêu cầu đang chờ",
    pendingCreators: "Yêu cầu nhà sáng tạo",
    pendingBusinesses: "Yêu cầu doanh nghiệp",
    revenue: "Doanh thu tạo ra",
    users: "Người dùng",
    verify: "Xác minh",
    verified: "Đã xác minh",
    myProfile: "Hồ sơ của tôi",
    editProfile: "Chỉnh sửa hồ sơ",
    role: "Vai trò",
    realisations: "Tác phẩm",
    views: "lượt xem",
  },
};

const I18nContext = createContext(null);

export function I18nProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem("lc_lang") || "fr");
  const toggle = useCallback(() => {
    setLang((l) => {
      const order = ["fr", "en", "vi"];
      const next = order[(order.indexOf(l) + 1) % order.length];
      localStorage.setItem("lc_lang", next);
      document.documentElement.lang = next;
      return next;
    });
  }, []);
  const t = useCallback((key) => (dict[lang] && dict[lang][key]) ?? dict.fr[key] ?? key, [lang]);
  return <I18nContext.Provider value={{ lang, t, toggle, setLang }}>{children}</I18nContext.Provider>;
}

export const useI18n = () => useContext(I18nContext);
